import { useParams, useSearchParams } from 'react-router-dom';

export const DEFAULT_AGENT_KEY = 'doc';

/**
 * Resolve the active agent key for an agent-scoped view. Order of precedence:
 *   1. the `:agentKey` route param, 2. the `?agent=` query param, 3. the Doc agent default.
 *
 * The existing Doc views carry no agent key and therefore resolve to "doc" — so they keep
 * working unchanged while every agent-scoped call is now parameterised.
 */
export function useAgentKey(): string {
  const params = useParams();
  const [search] = useSearchParams();
  return params.agentKey || search.get('agent') || DEFAULT_AGENT_KEY;
}

export default useAgentKey;
